<template>
  <!-- larger screen -->
  <div class="col-xs-6 text-right hidden-xs">
    <template v-if="isAuthenticated">
      <a
        name="download_quotation_link"
        :href="getDownloadQuotationLink()"
        target="_blank"
        class="btn btn-default"
        style="margin-right: 10px;"
      >
        <i class="fa fa-file-text-o"></i> {{ translate('Quotation') }}
      </a>
      <a
        name="download_proforma_invoice_link"
        :href="getDownloadProformaInvoiceLink()"
        target="_blank"
        class="btn btn-default"
      >
        <i class="fa fa-file-text-o"></i> {{ translate('Proforma Invoice') }}
      </a>
    </template>
    <template v-else>
      <button style="margin-right: 10px;" type="button" class="btn btn-default" @click="openModal('quotation')" id="view_quotation">
          <i class="fa fa-file-text-o"></i> {{ translate('Quotation') }}
      </button>
      <button type="button" class="btn btn-default" @click="openModal('proforma_invoice')" id="view_proforma_invoice">
          <i class="fa fa-file-text-o"></i> {{ translate('Proforma Invoice') }}
      </button>
    </template>
  </div>
  <div class="col-xs-6 hidden-xs">
    <a
        v-if="product.Cat.includes('WhatsApp')"
        :href="`/page/pricing/whatsapp_price/${routeCountry}-${currency.code}`"
        class="btn btn-danger"
    >
        <i class="fa fa-reply"></i> {{ translate('Other Package') }}
    </a>
    <a
        v-else
        :href="`/page/pricing/sms_price/${routeCountry}-${currency.code}`"
        class="btn btn-danger"
    >
        <i class="fa fa-reply"></i> {{ translate('Other Package') }}
    </a>
  </div>
  <!-- end larger screen -->

  <!-- smaller screen -->
  <div class="col-xs-12 hidden visible-xs">
    <div style="margin-bottom:5px;">
      <template v-if="isAuthenticated">
        <a
          name="download_quotation_link"
          :href="getDownloadQuotationLink()"
          target="_blank"
          class="btn btn-default "
          style="margin-right: 5px;margin-left:20px;"
        >
          <i class="fa fa-file-text-o"></i> {{ translate('Quotation') }}
        </a>
        <a
          name="download_proforma_invoice_link"
          :href="getDownloadProformaInvoiceLink()"
          target="_blank"
          class="btn btn-default"
          style="margin-right: 10px;"
        >
          <i class="fa fa-file-text-o"></i> {{ translate('Proforma Invoice') }}
        </a>
      </template>
      <template v-else>
        <button style="margin-right: 10px;" type="button" class="btn btn-default" @click="openModal('quotation')" id="view_quotation">
            <i class="fa fa-file-text-o"></i> {{ translate('Quotation') }}
        </button>
        <button type="button" class="btn btn-default" @click="openModal('proforma_invoice')" id="view_proforma_invoice" style="margin-right: 15px;">
            <i class="fa fa-file-text-o"></i> {{ translate('Proforma Invoice') }}
        </button>
      </template>
      <a
          v-if="product.Cat.includes('WhatsApp')"
          :href="`/page/pricing/whatsapp_price/${routeCountry}-${currency.code}`"
          class="btn btn-danger"
      >
          <i class="fa fa-reply"></i> {{ translate('Other Package') }}
      </a>
      <a
          v-else
          :href="`/page/pricing/sms_price/${routeCountry}-${currency.code}`"
          class="btn btn-danger"
      >
          <i class="fa fa-reply"></i> {{ translate('Other Package') }}
      </a>
    </div>
  </div>
  <!-- end smaller screen -->
  
  <!-- Form Modal for Quotation and Proforma Invoice for non-logged in users -->
  <div v-if="isModalVisible" id="proforma" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="proforma" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h4 class="modal-title" id="box-header-text">{{ modalTitle }}</h4>
          <div class="box-tools pull-right">
            <button type="button" class="close" @click="closeModal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <form action="" method="GET" target="_blank" @submit.prevent="submitForm" id="proforma_quotation_form">
          <input type="hidden" name="_token" :value="csrfToken" />
          <div class="form-group required" v-for="(field, index) in fields" :key="index" >
            <div v-show="field.name !== 'productID'">

              <label :for="field.name" class="col-sm-2 control-label" style="font-size:14px;margin-bottom:5px;">{{ translate(field.label) }}</label>
              <div class="col-sm-10">
                <input v-if="field.type === 'text'" 
                       :id="field.name" 
                       v-model="formData[field.name]" 
                       class="form-control" 
                       :placeholder="translate(field.placeholder)"
                       :required="true" 
                       style="margin-bottom:5px;"/>
                <textarea v-if="field.type === 'textarea'" 
                          :id="field.name" 
                          v-model="formData[field.name]" 
                          class="form-control" 
                          :placeholder="translate(field.placeholder)" 
                          rows="5" 
                          :required="true"
                          style="margin-bottom:5px;">
                </textarea>
    
                <div>
                  <VMultiselect
                    v-if="countries && countries.length > 0 && field.type === 'select'"
                    v-model="selectedCountry"
                    :options="filteredOptions"
                    :searchable="true"
                    track-by="alpha3"
                    label="country_name"
                    :custom-label="customLabel"
                    :internal-search="false"
                    @search-change="updateSearch"
                    @update:model-value="handleCountryChange"
                    placeholder="Country"
                    @click="debugDropdown" 
                    @open="scrollToSelectedCountry"
                  >

                    <!-- Custom option template -->
                    <template #option="{ option }">
                      <div class="country-item" v-if="option">
                        <img
                          :src="`${flagPath}${option.alpha2.toLowerCase()}.png`"
                          alt="flag"
                          class="flag-icon"
                        />
                        <span>&nbsp;&nbsp;{{ getLocalizedCountryName(option) }}</span>
                      </div>
                    </template>

                    <!-- Custom selected option template -->
                    <template v-slot:singleLabel="{ option }">
                      <!-- <div v-if="option">
                        <p>DEBUG: Selected option is {{ option }}</p>
                      </div> -->
                      <div class="country-item" v-if="option">
                        <img
                          :src="`${flagPath}${option.alpha2.toLowerCase()}.png`"
                          alt="flag"
                          class="flag-icon"
                        />
                        <span>&nbsp;&nbsp;{{ getLocalizedCountryName(option) }}</span>
                      </div>
                    </template>
                  </VMultiselect>
                  <span v-if="formSubmitted && !selectedCountry && field.type === 'select'" class="invalid-feedback h6">{{ translate('Country is required') }}</span>
                  <span v-if="errors[field.name]" class="invalid-feedback" role="alert">
                    <strong>{{ errors[field.name] }}</strong>
                  </span>
                </div>
                
                <!-- SST Note (conditionally shown) -->
                <span v-if="sstNoteVisible && field.type === 'select'" class="invalid-feedback h6" role="alert" name="sst_note" id="sst_note">
                  {{ translate('Please be awared of SST charges applied') }}
                </span>
              </div>
            </div>
          </div>


          <div class="modal-footer" style="border-top: 0px">
            <div class="text-left">
              <a id="loginLink" :href="redirectUrl" class="text-center" target="_blank" style="font-size:14px">{{ translate('I already have a membership') }}</a>
            </div>
            <button type="button" class="btn btn-secondary" @click="closeModal">{{ translate('Close') }}</button>
            <button type="submit" class="btn btn-primary" id="view-button-text">{{ buttonText }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import VMultiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
export default {
  components: { VMultiselect },
  props: {
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
    encodedProduct: {
      type: Object,
      required: true,
    },
    routeCountry: {
      type: String,
      required: true,
    },
    currency: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    country: {
      type: String,
      required: true,
    },
    countries: {
      type: Array,
      required: true,
    },
    userLanguage: {
      type: String,
      required: true,
    },
    flagPath: {
      type: String,
      required: true,
    },
    routes: {
      type: Object,
      required: true,  // Make sure routes is passed as a required prop
    },
  },
  data() {
    return {
      searchQuery: "",
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      selectedCountry: null,
      isModalVisible: false, // Controls visibility of the modal
      sstNoteVisible: false,
      formSubmitted: false,
      formData: {
        name: '',
        email: '',
        mobile: '',
        company: '',
        address: '',
        country: '',
        productID: this.encodedProduct.encodedId || '', // Additional form field (hidden)
      },
      errors: {}, // To store validation errors
      fields: [
        { name: 'name', label: 'Name', placeholder: 'Name', type: 'text' },
        { name: 'email', label: 'Email', placeholder: 'Email', type: 'text' },
        { name: 'mobile', label: 'Mobile', placeholder: 'Mobile', type: 'text' },
        { name: 'company', label: 'Company', placeholder: 'Company Name', type: 'text' },
        { name: 'address', label: 'Address', placeholder: 'Address', type: 'textarea' },
        { name: 'country', label: 'Country', placeholder: 'Select Country', type: 'select', options: [] },
        { name: 'productID', label: 'Product ID', placeholder: 'Product ID', type: 'text',  }
      ],
      sstNoteVisible: false, // Controls SST note visibility
      modalTitle: '',          // To hold the title for modal
      buttonText: '',          // To hold the button text for submission
    };
  },
  emits: ['country-changed'],
  mounted() {
    // Once the component is mounted, set the default value for productID
    // console.log('Encoded Product:', this.encodedProduct);
    // console.log('countries:', this.countries);
    // console.log('flagPaths:', this.flagPath);
  },
  computed: {
    filteredOptions() {
      // If there is no search query, show all countries.
      if (!this.searchQuery) {
        return this.countries;
      }
      const query = this.searchQuery.toLowerCase();
      // Filter options by checking if the query exists in any of the three properties.
      return this.countries.filter(option => {
        return (
          (option.country_name && option.country_name.toLowerCase().includes(query)) ||
          (option.cn && option.cn.toLowerCase().includes(query)) ||
          (option.my && option.my.toLowerCase().includes(query))
        );
      });
    }
  },
  watch: {
    selectedCountry(newVal) {
      if(!newVal) {
        return;
      }
      // console.log("Watcher detected country change:", newVal.alpha3);
      // this.handleCountryChange(newVal);
    },
  },
  methods: {
    debugDropdown() {
      console.log("Dropdown clicked");
      // console.log('Countries:', JSON.parse(JSON.stringify(this.countries)));
    },
    scrollToSelectedCountry() {
      this.$nextTick(() => {
        const selected = this.countries.find(c => c.alpha3 === this.selectedCountry?.alpha3);
        if (selected) {
          const index = this.countries.indexOf(selected);
          const dropdown = document.querySelector('.multiselect__content-wrapper');
          if (dropdown && index !== -1) {
            const optionHeight = dropdown.scrollHeight / this.countries.length;
            dropdown.scrollTop = index * optionHeight;
          }
        }
      });
    },
    handleCountryChange(selectedCountry) {
      // console.log("Selected country:", selectedCountry);
      if (!selectedCountry) {
        // Reset formData and any related properties if nothing is selected.
        this.formData.country = "";
        this.sstNoteVisible = false;
        return;
      }
      // Update formData with the selected country
      this.formData.country = selectedCountry.alpha3;
      this.$emit('country-changed', selectedCountry);

      if (selectedCountry.alpha3 === 'MYS') {
        this.sstNoteVisible = true;
      } else {
        this.sstNoteVisible = false;
      }
    },
    getLocalizedCountryName(country) {
      if (this.userLanguage === "cn") return country.cn || country.country_name;
      if (this.userLanguage === "my") return country.my || country.country_name;
      return country.country_name;
    },
    updateSearch(search) {
      // This method is triggered by the @search-change event.
      // It updates the searchQuery data property.
      console.log("Search changed:", search);
      this.searchQuery = search;
    },
    customLabel(item) {
      if (!item) return "Unknown"; // Handle null or undefined items
      return this.getLocalizedCountryName(item);
    },
    submitForm() {
      this.formSubmitted = true;
      if (!this.selectedCountry) {
        // alert("Country is required.");
        return;
      }
       // Ensure formData is appended to the form for submission
      const form = document.getElementById("proforma_quotation_form");
      
      // Clear any existing inputs to avoid duplicates
      const existingInputs = form.querySelectorAll('.dynamic-field');
      existingInputs.forEach(input => input.remove());
      
      // Append each field from formData as a hidden input
      Object.keys(this.formData).forEach(key => {
          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = key;
          hiddenInput.value = this.formData[key];
          hiddenInput.className = 'dynamic-field'; // Mark dynamically added fields
          form.appendChild(hiddenInput);
      });

      if (this.redirectUrl) {
          form.action = this.redirectUrl;
          // form.target = '_blank'; // Open in a new tab
          form.submit();
      } else {
          console.error("No redirect URL set.");
      }
    },
    openModal(type) {
      this.isModalVisible = true;

      const encodedId = this.encodedProduct.encodedId;
      const encodedRouteCountry = btoa(this.routeCountry);
      const encodedCurrency = btoa(this.currency.code);
      const amount = this.product.Price;
      if (type === 'quotation') {
          this.modalTitle = this.translate('Info required to generate Quotation:');
          this.buttonText = this.translate('View Quotation');
          this.redirectUrl = `${this.routes.routeDownloadQuotation}/${encodedId}/${amount}/${encodedRouteCountry}/${encodedCurrency}`;
          console.log("quotation redirectUrl = " + this.redirectUrl);
      } else if (type === 'proforma_invoice') {
          this.modalTitle = this.translate('Info required to generate Proforma Invoice:');
          this.buttonText = this.translate('View Proforma Invoice');
          this.redirectUrl = `${this.routes.routeDownloadProformaInvoice}/${encodedId}/${amount}/${encodedRouteCountry}/${encodedCurrency}`;
          console.log("proforma_invoice redirectUrl = " + this.redirectUrl);
      }
      console.log("openModal");

      const loginLink = document.getElementById("loginLink");
      if (loginLink) {
          loginLink.href = this.redirectUrl;
      }

      this.$nextTick(() => {
          $('#proforma').modal('show');
      });
    },
    closeModal() {
      $('#proforma').modal('hide'); // Hides the modal using Bootstrap
      this.isModalVisible = false;
      console.log("closeModal");
    },
    // submitForm() {
    //   // Handle form submission logic
    //   // Example: You can make an AJAX request here or emit an event to parent
    //   console.log(this.formData);
    // },
    getDownloadQuotationLink() {
      const encodedId = this.encodedProduct.encodedId;
      const encodedRouteCountry = btoa(this.routeCountry);
      const encodedCurrency = btoa(this.currency.code);
      const amount = this.product.Price;

      if(!this.selectedCountry){
        if (this.country === 'MYS') {
          return `/download_quotation/${encodedId}/${amount}/${encodedRouteCountry}/${encodedCurrency}`;
        } else {
          return `/download_quotation/${encodedId}/${amount}/${encodedRouteCountry}/${encodedCurrency}`;
        }
      }else{
        if (this.selectedCountry.alpha3 === 'MYS') {
          return `${this.routes.routeDownloadQuotation}/${encodedId}/${amount}/${encodedRouteCountry}/${encodedCurrency}`;
        }
      }
      
    },
    getDownloadProformaInvoiceLink() {
      const encodedId = this.encodedProduct.encodedId;
      const encodedRouteCountry = btoa(this.routeCountry);
      const encodedCurrency = btoa(this.currency.code);
      const amount = this.product.Price;
      if (this.country === 'MYS') {
        return `/proforma_invoice/${encodedId}/${amount}/${encodedRouteCountry}/${encodedCurrency}`;
      } else {
        return `/proforma_invoice/${encodedId}/${amount}/${encodedRouteCountry}/${encodedCurrency}`;
      }
    },
    translate(key) {
      return this.$parent.translate(key);
    },
  },
};
</script>
<!-- <style src="vue-multiselect/dist/vue-multiselect.css"></style> -->
<style>
.country-item {
  display: flex;
  align-items: center;
}
.country-item img {
  width: 20px;
  height: 15px;
  margin-right: 8px;
}
.flag-icon {
  width: 20px;
  height: 15px;
  margin-right: 8px;
}
.multiselect__option--highlight {
  background: rgba(0, 0, 0, 0.1) !important; /* Change green to blue */
  color: black; /* Ensure the text is readable */
}
.multiselect__option--highlight::after{
  background: rgba(255, 255, 255, 0.01) !important;
  color: white !important;
}
</style>

<!-- <style scoped>
.country-item img {
  width: 20px;
  height: auto;
  vertical-align: middle;
}
.country-item span {
  vertical-align: middle;
}
</style> -->